module.exports = __webpack_public_path__ + "static/best_prices-022bd84b5d85f45ea85e9e5f40135f51.png";